import BotoesSalvarExcluir from '@/shared/components/forms/BotoesSalvarExcluir';
import Links from '@/shared/constants/navegacao';
import ModalExcluir from '@/shared/components/modals/ModalExcluir';
import ModalHistorico from '@/modules/system/historico/ModalHistorico';
import { EditadoPorRodape } from '@/shared/components/EditadoPorRodape';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { useNavigate } from 'react-router-dom';
import { ReadComarcaDto } from '@/api.types';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Tabelas } from '@/shared/constants/tables';
import { createComarca } from '@/modules/structure/comarca/comarca.service';
import { deleteComarca, readComarca, updateComarca, } from '@/modules/structure/comarca/comarca.service';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

export default function ComarcaEditPage() {
  const { register, handleSubmit, reset, getValues } = useForm<ReadComarcaDto>();
  const { setActions } = useBreadcrumbActions();
  const navigate = useNavigate();
  const params = useParams();
  const [modaExcluirShow, setModalExcluirShow] = useState(false);
  const [modalHistorico, setModalHistorico] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const id = params.id ? Number(params.id) : 0;
  const btnSalvar = id > 0 ? 'Salvar' : 'Cadastrar';

  useEffect(() => {
    setActions({
      secondary: { label: 'Nova', onClick: () => { reset({}); navigate(`${Links.Comarcas_Criar}`); } },
      history: { label: 'Histórico', onClick: () => setModalHistorico(true) },
    });
    return () => setActions({});
  }, [setActions, reset, navigate]);

  useEffect(() => {
    if (id > 0)
      readComarca({ id: id })
        .then((result) => {
          if (result)
            reset(result[0][0]);
        })
        .catch((res) => {
          toast.error(String(res));
        });
  }, []);

  const onSubmit: SubmitHandler<ReadComarcaDto> = (data) => {
    setIsLoading(true);

    if (data.id) {
      updateComarca(data)
        .then(() => {
          toast.success("Comarca Atualizada.");
          navigate(`${Links.Comarcas_Index}`);
        })
        .catch((res) => {
          toast.error(String(res));
        })
        .finally(() => setIsLoading(false));
    } else {
      createComarca(data)
        .then(() => {
          toast.success("Comarca Cadastrada.");
          navigate(`${Links.Comarcas_Index}`);
        })
        .catch((res) => {
          toast.error(String(res));
        })
        .finally(() => setIsLoading(false));
    }
  };

  const handleExcluir = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    setModalExcluirShow(false);
    deleteComarca(id)
      .then(() => {
        toast.warning("Comarca Removida.");
        navigate(`${Links.Comarcas_Index}`);
      })
      .catch((res) => {
        toast.error(String(res));
      });
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h3 className="pt-4">Comarca</h3>
        </div>
      </div>
      <hr className="pb-4" />

      <form
        onSubmit={(event) => {
          void handleSubmit(onSubmit)(event);
        }}
      >
        <div className="row">
          <div className="mb-3 col-md-1">
            <label htmlFor="ordem" className="form-label">
              Ordem:{' '}
            </label>
            <input
              id="ordem"
              type="number"
              title="Ordem no relatório"
              className="form-control"
              min={0}
              {...register('ordem')}
            />
          </div>

          <div className="mb-3 col-md-2">
            <label htmlFor="prefixo" className="form-label">
              Prefixo:
            </label>
            <input
              id="prefixo"
              title="Prefixo antes do relatório"
              type="text"
              className="form-control"
              {...register('prefixo')}
            />
          </div>

          <div className="mb-3 col-md-5">
            <label htmlFor="nome" className="form-label">
              Nome:
            </label>
            <input
              id="nome"
              autoFocus={true}
              title="Nome"
              type="text"
              className="form-control"
              {...register('nome')}
            />
          </div>

          <div
            className="mb-3 mt-4 col-md-4 form-check align-middle"
            title="Agrupar essa comarca junto com outras no relatório."
          >
            <label className="form-check-label" htmlFor="agrupar">
              Agrupar no Relátorio
            </label>
            <input
              id="agrupar"
              className="form-check-input"
              title="Agrupar"
              type="checkbox"
              {...register('agrupar')}
            />
          </div>

          <EditadoPorRodape
            dados={{
              editadoPor: { username: getValues().editadoPor?.username },
              editadoEm: getValues().editadoEm,
            }}
          />

          <div>
            <BotoesSalvarExcluir
              isLoading={isLoading}
              texto={btnSalvar}
              textoLoading={btnSalvar === 'Cadastrar' ? ' Cadastrando...' : ' Salvando...'}
              id={id}
              onExcluirClick={() => setModalExcluirShow(true)}
            />
          </div>
        </div>
      </form>

      <ModalExcluir
        show={modaExcluirShow}
        handleExcluir={handleExcluir}
        handleHide={() => setModalExcluirShow(false)}
      ></ModalExcluir>
      <ModalHistorico
        show={modalHistorico}
        handleHide={() => setModalHistorico(false)}
        tabela={Tabelas.comarca}
        idRegistro={id}
      ></ModalHistorico>
    </>
  );
}
